import { useContext, useEffect, useState } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { CompanyUserMembershipsQuery } from 'interfaceAdapter/queries/CompanyUserMemberships';
import { CompanyUserSwitchCompanyRepository } from 'interfaceAdapter/repositories/CompanyUserSwitchCompany';

type Membership = {
    company_id: number;
    company_name: string | null;
    company_label: string | null;
    role: number;
};

export const useCompanySwitcher = () => {
    const diContainer = useContext(diContainerContext);
    const membershipsQuery = diContainer.resolve(CompanyUserMembershipsQuery);
    const switchRepo = diContainer.resolve(CompanyUserSwitchCompanyRepository);

    const [memberships, setMemberships] = useState<Membership[]>([]);
    const [currentCompanyId, setCurrentCompanyId] = useState<number | null>(null);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const data = await membershipsQuery.fetch();
                setMemberships(data.memberships);
                setCurrentCompanyId(data.current_company_id);
            } catch {
                // セッション無効等は上位レイヤがハンドリング
            }
        })();
    }, []);

    const current = memberships.find((m) => m.company_id === currentCompanyId) ?? null;

    const onSwitch = async (companyId: number) => {
        if (companyId === currentCompanyId) {
            setOpen(false);
            return;
        }
        setLoading(true);
        try {
            await switchRepo.switchCompany(companyId);
            window.location.reload();
        } catch {
            setLoading(false);
            alert('企業の切替に失敗しました');
        }
    };

    return { memberships, current, open, setOpen, loading, onSwitch };
};
